/** DB club_tipo enum ↔ UI labels used in Clubs / AdminQueue / ClubCard */
export const CLUB_TIPO_TO_UI = {
  mateada: 'Mateada',
  asado: 'Asado',
  otro: 'Otro',
};

export const CLUB_TIPO_TO_DB = {
  Mateada: 'mateada',
  Asado: 'asado',
  Otro: 'otro',
  mateada: 'mateada',
  asado: 'asado',
  otro: 'otro',
};

export function clubTipoToUi(tipo) {
  return CLUB_TIPO_TO_UI[tipo] || tipo;
}

export function clubTipoToDb(tipo) {
  return CLUB_TIPO_TO_DB[tipo] || String(tipo || '').toLowerCase();
}

export function mapClubFromDb(row) {
  if (!row) return null;
  return {
    ...row,
    tipo: clubTipoToUi(row.tipo),
    foto_portada: row.foto_url,
  };
}

export function mapClubSuggestionFromDb(row) {
  if (!row) return null;
  const suggester = row.suggested_by_member || row.members;
  return {
    id: row.id,
    nombre: row.nombre_sugerido,
    descripcion: row.descripcion,
    tipo: clubTipoToUi(row.tipo),
    capitulo_id: row.capitulo_id,
    suggested_by: row.suggested_by,
    suggested_by_name: suggester?.nombre || 'Miembro',
    status: row.status,
    created_club_id: row.created_club_id,
    created_at: row.created_at,
  };
}
